import type { SolverSettingsModalProps } from "@/components/modals/SolverSettingsModal.types.ts";
import SolverSettingsOptions, { buildSolverSettingController } from "@/components/sections/SolverSettingsOptions.tsx";
import React, { useEffect } from "react";
import Modal from "./Modal";
import SolverPhaseConfig, { buildSolverPhaseConfigController } from "@/components/sections/SolverPhaseConfig.tsx";
import type { SolverPhaseConfigModalProps } from "@/components/modals/SolverPhaseConfigModal.types.tsx";







/**
 * Main component
 * @param param0
 * @returns 
 */
const SolverPhaseConfigModal: React.FC<SolverPhaseConfigModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        onRemove,
        title,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        removeLabel= "Effacer",
        confirmDisabled = false,
        phase = {},
        phaseId ,
        schedule
    }) => {
    
    const ctrl = buildSolverPhaseConfigController(phase,phaseId);
    //const [editData , setEditData] = useState({...{},...solverConfigs});


    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(()=>{
        if(open){
            ctrl.setEditData({...{},...phase});
        }
    },[open]);

    const handleConfirm = () => {
        onConfirm(ctrl.editData,phaseId);
        onClose();
    };

    const handleRemove = () => {
        onRemove(phaseId);
        onClose();
    };


    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            size="md"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        {cancelLabel}
                    </button>
                    {
                        ctrl.viewData.isNew ? '' : <button
                            onClick={handleRemove}
                            className="inline-flex items-center rounded-full bg-red-500 cursor-pointer px-4 py-2 font-medium text-white hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            {removeLabel}
                        </button>
                    }
                    <button
                        onClick={handleConfirm}
                        disabled={confirmDisabled}
                        className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${confirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                    >
                        {confirmLabel}
                    </button>
                </>
            }
        >
            <SolverPhaseConfig 
                schedule={schedule}
                controller={ctrl}> 

            </SolverPhaseConfig>

        </Modal>
    );
};

export default SolverPhaseConfigModal;
